'use strict';

const getNotEmptyTraits = require('./get_non_empty_traits');
const getCheapestOptionFromSelectedTraits = require('./get_cheapest_option');

module.exports = (
  pageType,
  isSelected,
  optionText,
  name,
  value,
  selectedTraits,
  dealOptions,
  traitsOptions,
  I18n
) => {
  if (pageType === 'getaways' && !isSelected) {
    const totalTraits = Object.keys(selectedTraits).length;
    const simulatedSelectedTraits = getNotEmptyTraits(selectedTraits);
    const selectionsRemaining =
      totalTraits - Object.keys(simulatedSelectedTraits).length;
    simulatedSelectedTraits[name] = value;
    const cheapestOption = getCheapestOptionFromSelectedTraits(
      simulatedSelectedTraits,
      dealOptions,
      traitsOptions
    );
    if (
      totalTraits === 1 ||
      selectionsRemaining === 0 ||
      (selectionsRemaining === 1 && !selectedTraits[name])
    ) {
      return `${optionText} (${cheapestOption.price.formattedAmount})`;
    } else {
      const fromText = I18n.t('js.modules.variations.from_price', {
        minPrice: cheapestOption.price.formattedAmount,
      });
      return `${optionText} (${fromText})`;
    }
  }
  return optionText;
};
